module.exports = "<div class=p-v> <div class=md-list-item-text style=width:370px> <p ng-class=projectsVm.projectText(project) class=\"text-color no-margin exo\"> <strong>{{ project.name }}</strong> </p> <p ng-class=projectsVm.projectText(project) class=\"text-sm no-margin proxima\"> Horas planeadas {{ project.hoursPlanned }} </p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/research/projects/list/jobs/list-data-project.html
// module id = 681
// module chunks = 0